import GokuDataGrid from '@/components/GokuDataGrid'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getSupplierCandidates } from '../../../services'
import { SupplierCandidateContact } from '../../../types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { supplierCandidateColumns } from './columns'

const SupplierCandidates = () => {
    const { t } = useTranslation('contract')
    const columns = useMemo(() => supplierCandidateColumns(t), [t])

    return (
        <div className="my-2">
            <GokuDataGrid<SupplierCandidateContact, SupplierCandidateContact>
                apiCall={getSupplierCandidates}
                columns={columns}
                reactQueryKey={`${QUERY_KEYS.SUPPLIERS}-candidates`}
                dataGridProps={{
                    getRowId: (row) => row?.customer_contact_id,
                }}
                searchPlaceholder={t('search-supplier-candidates')}
            />
        </div>
    )
}

export default SupplierCandidates
